import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a floor-standing toilet: porcelain pedestal and bowl,
// closed seat + lid slab on top, cistern against the wall at -Z with a small
// steel flush button on its top face. Seat height ~0.44 m, tank top ~0.8 m.
const PORCELAIN = "#f2f0ea";
const SEAT = "#efece6";
const STEEL = "#aab2b8";

export const toilet = defineModel({
  id: "toilet",
  batchId: "modern",
  name: "Toilet",
  tags: ["modern", "interior", "fixture", "bathroom", "toilet"],
  summary: "A porcelain toilet with a closed seat and a back cistern.",
  tiles: { w: 1, h: 1 },
  footprint: 0.6,
  parts(): Part[] {
    return [
      // pedestal base
      { geometry: new THREE.BoxGeometry(0.26, 0.3, 0.32), color: PORCELAIN, position: [0, 0.15, 0.06] },
      // bowl (widens towards the rim)
      {
        geometry: new THREE.CylinderGeometry(0.2, 0.14, 0.14, 12),
        color: PORCELAIN,
        position: [0, 0.36, 0.08],
      },
      // seat slab
      { geometry: new THREE.BoxGeometry(0.4, 0.035, 0.44), color: SEAT, position: [0, 0.448, 0.05] },
      // closed lid slab
      { geometry: new THREE.BoxGeometry(0.36, 0.03, 0.4), color: PORCELAIN, position: [0, 0.48, 0.05] },
      // cistern at the back (against the wall on -Z)
      { geometry: new THREE.BoxGeometry(0.42, 0.42, 0.16), color: PORCELAIN, position: [0, 0.6, -0.2] },
      // flush button on the cistern top
      { geometry: new THREE.BoxGeometry(0.1, 0.02, 0.06), color: STEEL, position: [0, 0.82, -0.2] },
    ];
  },
  animations: [],
});
